import { render, staticRenderFns } from "./zhCn.vue?vue&type=template&id=0a627700&scoped=true&"
import script from "./zhCn.vue?vue&type=script&lang=ts&"
export * from "./zhCn.vue?vue&type=script&lang=ts&"
import style0 from "./zhCn.vue?vue&type=style&index=0&id=0a627700&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a627700",
  null
  
)

export default component.exports